import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetOrgUnitNonAthleteEntryData = (orgUnitNonAthleteEntryId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const orgUnitNonAthleteEntryIdForUrl = orgUnitNonAthleteEntryId ? encodeURIComponent(orgUnitNonAthleteEntryId) : 'NaN';
    const url = `/OrgUnitNonAthleteEntry/${orgUnitNonAthleteEntryIdForUrl}`;
    MeetHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default GetOrgUnitNonAthleteEntryData;